module.exports = __webpack_public_path__ + "static/media/innerspaces3.4b6d2fa8.jpg";